import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';

// React 18 방식으로 앱 렌더링
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// 성능 측정을 원하는 경우 아래 주석을 해제하고 사용
// import reportWebVitals from './reportWebVitals';
// reportWebVitals(console.log);